import GetOffices from '@/graphql/GetOffices.gql'
import { createProvider } from '../../vue-apollo'

const apollo = createProvider()

export default {
  async getOffices ({ dispatch, commit }, { pageNumber, perPage }) {
    try {
      const { data, erros } = await apollo.defaultClient.query({
        query: GetOffices,
        etchPolicy: 'no-cache',
        variables: {
          pageNumber,
          perPage
        }
      })
      return { data, erros, pagination: data.getOffices.pagination }
    } catch (err) {
      dispatch('showError', err)
    }
  }
}
